import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../selectors/publishAvailable';
import { selectIsPublicationWrapperVisible } from '../../selectors/elementsVisibility';
import { selectIsSubagentLimitExceed } from '../../selectors/publishTerms';
import { PublicationSectionContainer } from './components/PublicationSection';
import { PublicationLayout } from './components/PublicationLayout/PublicationLayout';
import { PublicationTitle } from './components/PublicationTitle';

export const PublicationContainer = () => {
  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);
  const isPublicationWrapperVisible = useSelector(selectIsPublicationWrapperVisible);
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);

  if (isIdentificationNeeded || isPublishToHiddenBase || !isPublicationWrapperVisible || isSubagentLimitExceed) {
    return null;
  }

  return (
    <div data-testid="publication">
      <PublicationLayout content={<PublicationSectionContainer />} title={<PublicationTitle />} />
    </div>
  );
};
